import _ from 'lodash'
import * as sentry from '../../src/utils/sentry'
import type { Hive } from '../../src/modules/hive'
import { isNew } from '../../src/utils/sync'
import { IDB_locationsReadAll } from '../IDB/IDB.table.location'
import { Loca_fetchTimelineEvents } from './Loca.fetchTimelineEvents'
import { Serv_send } from '../Serv/Serv.socketClient'
import type { Sync_SyncResult } from '../Sync/Sync.master'
import type { Type_ILocationTimelineEvent } from '../Type/Type.hive'
import {
    IDB_locationTimelineEventsReadAll,
    IDB_locationTimelineEventsWrite,
} from '../IDB/IDB.table.locationTimelineEvent'

export async function Loca_syncTimelineEvents(hive: Hive, data: Sync_SyncResult, updateTimeline: () => void) {
    if (_.isUndefined(data.response.locations)) {
        data.response.locations = []
    }

    const newLocations = data.response.locations

    // Upload all local changes to the timeline
    const locationTimelines = await IDB_locationTimelineEventsReadAll()

    await uploadNewEvents(locationTimelines)

    // Fetch the latest from the server which should now include our changes
    const currentLocations = await IDB_locationsReadAll()

    // Get location timelines again to account for any updates
    const locationTimelinesUpdated = await IDB_locationTimelineEventsReadAll()

    const locationIds = _.uniq(
        _.concat(
            currentLocations.map((l) => l.id),
            newLocations.map((l) => l.id)
        )
    )

    await Loca_fetchTimelineEvents(hive, locationTimelinesUpdated, locationIds, updateTimeline)
}

async function uploadNewEvents(locationTimelines: Type_ILocationTimelineEvent[]) {
    for (const timeline of locationTimelines) {
        const newEvents = timeline.events.filter(isNew)
        const sentIds = new Set()
        for (const event of newEvents) {
            // Convert to format for server
            const data = {
                date: event.date,
                type: event.type,
                item: event.item,
                location: timeline.id,
            }

            // Send all new events to the server & record the ids of those that have
            // been successfully sent
            try {
                await Serv_send('timeline.set', data as any)
                sentIds.add(event.id)
            } catch (error) {
                sentry.err(error, { extra: { data, context: 'Unable to add timeline event' } })
                continue
            }
        }

        if (sentIds.size > 0) {
            // Remove the sent events from the timeline as we expect to get them back from the server
            const newTimeline = {
                ...timeline,
                events: timeline.events.filter((event) => !sentIds.has(event.id)),
            }

            await IDB_locationTimelineEventsWrite([newTimeline])
        }
    }
}
